module.exports = __webpack_public_path__ + "static/q20_x-481657781ef48036033caad1b3577334.png";